import { formatDateTextShort } from "utils/formatDate";
import API from "../api/api";

/**
 * DashboardService
 * ----------------
 * Talks to the new `/distributor-dashboard/*` endpoints.
 * Distributor scope is inferred by the backend from the scoped JWT.
 */
export class DashboardService {
  today = new Date();
  firstDayOfYear = new Date(this.today.getFullYear(), 0, 1);

  // Revenue / orders / exposure metrics (top-line + graphs).
  async getDashboardData(fromDate?: string, toDate?: string) {
    const response = await API.get(
      `/distributor-dashboard/overview${this.buildRange(fromDate, toDate)}`
    );

    return {
      ...response.data,
      marketplaceImpressionsGraph: response.data.marketplaceImpressionsGraph?.map(
        ({ impressions, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: impressions,
        })
      ),
      revenueGraph: response.data.revenueGraph?.map(
        ({ revenuePartner, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value: revenuePartner,
        })
      ),
    };
  }

  // Per-merchant breakdown.
  async getDashboardMerchants(fromDate?: string, toDate?: string) {
    const response = await API.get(
      `/distributor-dashboard/merchant-breakdown${this.buildRange(fromDate, toDate)}`
    );
    return response.data?.merchants ?? response.data;
  }

  // Cumulative trends (uses the same overview endpoint).
  async getDashboardDataByPeriod(fromDate?: string, toDate?: string) {
    const response = await API.get(
      `/distributor-dashboard/overview${this.buildRange(fromDate, toDate)}`
    );

    const body = response.data?.body ?? response.data;

    return {
      ...body,
      impressionTrend: body.impressionTrend?.map(
        ({ value, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value,
        })
      ),
      revenueTrend: body.revenueTrend?.map(
        ({ value, date, ...rest }: any) => ({
          ...rest,
          label: formatDateTextShort(date),
          value,
        })
      ),
    };
  }

  private buildRange(fromDate?: string, toDate?: string): string {
    const params = new URLSearchParams();
    if (fromDate) params.append("from", fromDate);
    if (toDate) params.append("to", toDate);
    const qs = params.toString();
    return qs ? `?${qs}` : "";
  }
}
